
import { Vue, Options } from "vue-class-component";
import { AccessLogApi, AuthApi, AccessLog, PageId } from "../../autogen";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import moment from "moment-timezone";
import Store from "../../store";
import Datepicker from "vue3-datepicker";
import { ja } from "date-fns/locale";
type FormValues = {
  name?: string;
  startDate?: Date;
  endDate?: Date;
  pageId?: string;
};
@Options({
  components: {
    Page,
    ActionButton,
    Table,
    Datepicker
  }
})
export default class AccessLogs extends Vue {
  accessLogs: AccessLog[] = [];
  header = [
    { title: "日時", sortable: true, key: "datetime", width: "expand" },
    { title: "画面", sortable: true, key: "pageName", width: "expand" },
    { title: "従業員", sortable: true, key: "userFullName", width: "expand" },
    { title: "対象", sortable: true, key: "targetName", width: "expand" },
    { title: "操作", sortable: true, key: "action", width: "expand" }
  ];
  filterColumns = ["userFullName"];
  query = "";
  offset?: string;
  FormValues: FormValues = {};
  pageIds: PageId[] = [];
  locale = ja;

  async beforeMount() {
    const pageIds = await new AccessLogApi().getPageIds({});
    this.pageIds = pageIds.data;
  }

  async getTableData() {
    if (this.offset === null) {
      return [];
    }
    const response = await new AccessLogApi().getAccessLogs(
      Object.assign({
        startDate: this.FormValues.startDate ? moment(this.FormValues.startDate).format("YYYY-MM-DD") : undefined,
        endDate: this.FormValues.endDate ? moment(this.FormValues.endDate).format("YYYY-MM-DD") : undefined,
        name: this.FormValues.name ? this.FormValues.name : undefined,
        pageId: this.FormValues.pageId ? this.FormValues.pageId : undefined,
        offset: this.offset ? this.offset : undefined
      })
    );
    this.offset = response.data.offset;
    if (!response.data.lists || !response.data.lists.length) return [];
    return response.data.lists.map(datum =>
      Object.assign(datum, {
        datetime: datum.datetime ? moment(datum.datetime).format("YYYY/MM/DD HH:mm") : "-",
        userFullName: datum.userFullName || "-",
        pageName: datum.pageName || "-",
        targetName: datum.targetName || "-",
        action: datum.action || "-"
      })
    );
  }
  onAccessLogSearch() {
    const table = this.$refs.tableComponent as Table;
    if (table) {
      this.offset = undefined;
      table.reset();
    }
  }
  async onSubmitted() {
    await new AuthApi().authenticate({}).then(resp => {
      if (resp.status === 200) {
        Store.getInstance().setAuth(resp.data);
      }
    });
    this.onAccessLogSearch();
  }

  resetConditions() {
    this.FormValues = {};
    this.onAccessLogSearch();
  }
}
